export const Complex = {
  NONE: {
    timeZone: "Turkey",
    region: "NONE",
    location: "NONE",
    description: "NONE",
    code: 0,
  },

  TurkeyTerminals: [
    {
      timeZone: "Turkey",
      region: "TR",
      location: "TR00",
      description: "TRGEB",
      code: 201,
    },
    {
      timeZone: "Turkey",
      region: "TR",
      location: "TR20",
      description: "TRGEM",
      code: 101,
    },
  ],

  TurkeySubTerminals: [
    {
      timeZone: "Turkey",
      region: "TR",
      location: "TR21",
      description: "TRGEMRORO",
      code: 103,
    },
    {
      timeZone: "Turkey",
      region: "TR",
      location: "TR00",
      description: "TRGEBINLAND",
      code: 202,
    },
    {
      timeZone: "Turkey",
      region: "TR",
      location: "TR05",
      description: "TRGEBE5",
      code: 203,
    },
    {
      timeZone: "Turkey",
      region: "TR",
      location: "TR192",
      description: "SOLVENTAS",
      code: 204,
    },
    {
      timeZone: "Turkey",
      region: "TR",
      location: "TR10",
      description: "ROTA",
      code: 205,
    },
    {
      timeZone: "Turkey",
      region: "TR",
      location: "TR20",
      description: "TRETILOJISTIKELAZIG",
      code: 104,
    },
    {
      timeZone: "Turkey",
      region: "TR",
      location: "TR20",
      description: "TRETILOJISTIKROTA",
      code: 105,
    },
    {
      timeZone: "Turkey",
      region: "TR",
      location: "TR",
      description: "TRYIL",
      code: 302,
    },
    {
      timeZone: "Turkey",
      region: "TR",
      location: "TR90",
      description: "ETILOJISTIKTRGEB",
      code: 1010,
    },
    {
      timeZone: "Turkey",
      region: "TR",
      location: "TR90",
      description: "ETILOJISTIKTRGEM",
      code: 1020,
    },
  ],

  NordicTerminals: [
    {
      timeZone: "Norway",
      region: "ND",
      location: "NO55",
      description: "NOOSL",
      code: 301,
    },
    {
      timeZone: "Sweden",
      region: "ND",
      location: "SE50",
      description: "GAVLE",
      code: 601,
    },
    {
      timeZone: "Sweden",
      region: "ND",
      location: "SE60",
      description: "STOCKHOLM",
      code: 501,
    },
  ],

  IberiaTerminals: [
    {
      timeZone: "Portugal",
      region: "IB",
      location: "PT70",
      description: "LISCONT",
      code: 401,
    },
    {
      timeZone: "Portugal",
      region: "IB",
      location: "IB",
      description: "FIGUEIRADAFOZ",
      code: 402,
    },
    {
      timeZone: "Portugal",
      region: "IB",
      location: "IB",
      description: "SOTAGUS",
      code: 403,
    },
    {
      timeZone: "Portugal",
      region: "IB",
      location: "PT72",
      description: "LEIXOES",
      code: 404,
    },
    {
      timeZone: "Portugal",
      region: "IB",
      location: "IB",
      description: "AVEIRO",
      code: 405,
    },
  ],

  LatinAmericaTerminals: [
    {
      timeZone: "Ecuador",
      region: "EC111",
      location: "EC111",
      description: "PUERTOBOLIVAR",
      code: 1002,
    },
    {
      timeZone: "Peru",
      region: "LA",
      location: "LA",
      description: "PAITA",
      code: 1003,
    },
  ],

  ElSalvadorPorts: [
    {
      timeZone: "ElSalvador",
      region: "EL",
      location: "PUERTO DE ACAJUTLA",
      description: "ACAJUTLA",
      code: 1100,
    },
    {
      timeZone: "ElSalvador",
      region: "EL",
      location: "PUERTO DE LA UNION",
      description: "LAUNION",
      code: 1101,
    },    
  ],
  GhanaPorts: [
    {
      timeZone: "Ghana",
      region: "AF",
      location: "GH121",
      description: "TAKORADI",
      code: 1030,
    },
  ],

  GuatemalaPorts: [
    {
      timeZone: "CentralAmerica",
      region: "CA",
      location: "CA",
      description: "QUETZAL",
      code: 1102,
    },
  ],
  Others: [
    {
      timeZone: "Turkey",
      region: "TR",
      location: "PBI",
      description: "POWERBI",
      code: 9999,
    },
    {
      timeZone: "Turkey",
      region: "ALL",
      location: "ALL",
      description: "ALL",
      code: 100,
    },
    {
      timeZone: "Turkey",
      region: "TR",
      location: "EL",
      description: "ETIKROM",
      code: 110,
    },
    {
      timeZone: "Guatemala",
      region: "CA",
      location: "CA",
      description: "GUATEMALA",
      code: 1005,
    },
  ],
};
